import Vue from 'vue'
// import Vuex from 'vuex'
import Router from 'vue-router'
import AddLaneClosureRequest from './views/LaneClosureRequest/Add.vue'
import AddLaneClosureRequestWithContravention from './views/LaneClosureRequest/AddWithContravention.vue'
import EditLaneClosureRequest from './views/LaneClosureRequest/Edit.vue'
import ViewLaneClosureRequest from './views/LaneClosureRequest/View.vue'
import LaneClosureRequestActivity from './views/LaneClosureRequest/Activity.vue'
import LaneClosureRequestContraventions from './views/LaneClosureRequest/Contraventions.vue'
import LaneClosureRequestAttachments from './views/LaneClosureRequest/Attachments.vue'

import Login from './views/Login.vue'
import LaneClosureList from './views/LaneClosureRequest/List.vue'
import Register from './views/Register.vue'
import ReportClosure from './views/LaneClosureRequest/ReportClosure.vue'
import ReportRestriction from './views/LaneClosureRequest/ReportRestriction.vue'
import ReportContravention from './views/LaneClosureRequest/ReportContravention.vue'
import EditContravention from './views/LaneClosureRequest/EditContravention.vue'
import ViewContravention from './views/LaneClosureRequest/ViewContravention.vue'

import NewOrganization from './views/Register/NewOrganization.vue'
import CreateAccount from './views/Register/CreateAccount.vue'
import CreateAccountFromPin from './views/Register/CreateAccountFromPin.vue'
import ConfirmOrganizationRegistration from './views/Register/ConfirmOrganizationRegistration.vue'
import ConfirmAppUserRegistration from './views/Register/ConfirmAppUserRegistration.vue'

import ResetPassword from './views/ResetPassword.vue'
import ForgotPassword from './views/ForgotPassword.vue'

import SetBlockDetails from './views/admin/BlockDirections/Details.vue'

import OrganizationList from './views/admin/Organization/List.vue'
import AddOrganization from './views/admin/Organization/Add.vue'
import EditOrganization from './views/admin/Organization/Edit.vue'
import AddPrimaryOrganization from './views/admin/Organization/AddPrimary.vue'
import UserList from './views/admin/User/List.vue'

import AuditLogList from './views/admin/AuditLog/List.vue'
import ViewAuditLog from './views/admin/AuditLog/View.vue'

import EditBanner from './views/admin/Banner/Edit.vue'


import OrganizationRequestList from './views/admin/OrganizationRequest/List.vue'
import EditOrganizationRequest from './views/admin/OrganizationRequest/Edit.vue'
import ApproveOrganizationRegistration from './views/admin/OrganizationRequest/Approve.vue'
import RejectOrganizationRegistration from './views/admin/OrganizationRequest/Reject.vue'
import NoAccess from './views/NoAccess.vue'

import AppUserRequestList from './views/admin/AppUserRequest/List.vue'
import EditAppUserRequest from './views/admin/AppUserRequest/Edit.vue'
import ApproveUserRegistration from './views/admin/AppUserRequest/Approve.vue'
import RejectUserRegistration from './views/admin/AppUserRequest/Reject.vue'


import AddUser from './views/admin/User/Add.vue'
import EditUser from './views/admin/User/Edit.vue'
import MySettings from './views/MySettings.vue'
import MyNotifications from './views/MyNotifications.vue'

import EditGlobalSettings from './views/admin/GlobalSettings/Edit.vue'

import ListNotificationSchedule from './views/admin/NotificationSchedule/List.vue'
import AddNotificationSchedule from './views/admin/NotificationSchedule/Add.vue'
import EditNotificationSchedule from './views/admin/NotificationSchedule/Edit.vue'

import ReportClosureSearch from './views/ReportClosureSearch/ReportClosureSearch.vue'
import ReportRestrictionSearch from './views/ReportRestrictionSearch/ReportRestrictionSearch.vue'
import ReportContraventionSearch from './views/ReportContraventionSearch/ReportContraventionSearch.vue'
import ContraventionList from './views/ReportContraventionSearch/ContraventionList.vue'
import UnderDevelopment from './views/UnderDevelopment.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		const fromHistory = Boolean(savedPosition);
		if (fromHistory && Vue.prototype.$routerStore.state.routerHistory.length > 0) {
			Vue.prototype.$routerStore.state.routerHistory.splice(-1, 1);
		} else {
			Vue.prototype.$routerStore.state.routerHistory.push(from);
		}
		return savedPosition || {
			x: 0,
			y: 0
		};
	},
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: LaneClosureList
 	   },
    		{
    			path: '/home',
			name: 'home2',
    			component: LaneClosureList
        },
		{
			path: '/login',
			name: 'login',
			component: Login
    },
		{
			path: '/register',
			name:'Register',
			component: Register
    },
		{
			path: '/register/:pin',
			name: 'RegisterWithPin',
			props: true,
			component: Register
        },
		{
			path: '/new-lane-closure-request',
			name: 'AddLaneClosureRequest',
			props: true,
			component: AddLaneClosureRequest
    },
		{
			path: '/duplicate-lane-closure-request/:id',
			name: 'DuplicateLaneClosureRequest',
			props: true,
			component: AddLaneClosureRequest
    },
		{
			path: '/new-lane-closure-request-with-contravention',
			name: 'AddLaneClosureRequestWithContravention',
			props: true,
			component: AddLaneClosureRequestWithContravention
    },
		{
			path: '/lane-closure-request/:id/view',
			name: 'ViewLaneClosureRequest',
			props: true,
			component: ViewLaneClosureRequest
    },
		{
    			path: '/lane-closure-request/:id/view/:cachebuster',
    			name: 'ViewLaneClosureRequestCacheBuster',
    			props: true,
    			component: ViewLaneClosureRequest
        },
		{
			path: '/lane-closure-request/:id/view-scroll/:scrollToRef',
			name: 'ViewLaneClosureRequestScrollTo',
			props: true,
			component: ViewLaneClosureRequest
    },
		{
			path: '/lane-closure-request/:id/edit',
			name: 'EditLaneClosureRequest',
			props: true,
			component: EditLaneClosureRequest
    },
		{
			path: '/lane-closure-request/:id/report-lane-closure',
			name: 'ReportClosure',
			props: true,
			component: ReportClosure
    },
		{
			path: '/lane-closure-request/:id/report-contravention',
			name: 'ReportContravention',
			props: true,
			component: ReportContravention
    },
		{
			path: '/lane-closure-request/:id/edit-contravention/:contraventionId',
			name: 'EditContravention',
			props: true,
			component: EditContravention
    },
		{
			path: '/lane-closure-request/:id/view-contravention/:contraventionId',
			name: 'ViewContravention',
			props: true,
			component: ViewContravention
    },

		{
			path: '/lane-closure-request/:id/activity',
			name: 'LaneClosureRequestActivity',
			props: true,
			component: LaneClosureRequestActivity
    },
		{
    			path: '/lane-closure-request/:id/activity/:cachebuster',
    			name: 'LaneClosureRequestActivityCacheBuster',
    			props: true,
    			component: LaneClosureRequestActivity
        },
		{
			path: '/lane-closure-request/:id/attachments',
			name: 'LaneClosureRequestAttachments',
			props: true,
			component: LaneClosureRequestAttachments
    },
		{
    			path: '/lane-closure-request/:id/attachments/:cachebuster',
    			name: 'LaneClosureRequestAttachmentsCacheBuster',
    			props: true,
    			component: LaneClosureRequestAttachments
        },


		{
			path: '/lane-closure-request/:id/contraventions',
			name: 'LaneClosureRequestContraventions',
			props: true,
			component: LaneClosureRequestContraventions
    },
		{
			path: '/lane-closure-request/:id/contraventions/:cachebuster',
			name: 'LaneClosureRequestContraventionsCacheBuster',
			props: true,
			component: LaneClosureRequestContraventions
    },
		{
			path: '/lane-closure-request/:id/report-restriction',
			name: 'ReportRestriction',
			props: true,
			component: ReportRestriction
    },
		{
			path: '/report-restriction',
			name: 'ReportRestrictionSearch',
			component: ReportRestrictionSearch
    },
		{
			path: '/report-contravention',
			name: 'ReportContraventionSearch',
			component: ReportContraventionSearch
    },
		{
			path: '/report-lane-closure',
			name: 'ReportClosureSearch',
			component: ReportClosureSearch
    },
		{
			path: '/no-access',
			name: 'NoAccess',
			component: NoAccess
        },
		{
			path: '/lane-closure-request-list',
			name: 'LaneClosureList',
			component: LaneClosureList
    },
		{
			path: '/admin/set-block-details',
			name: 'SetBlockDetails',
			component: SetBlockDetails
    },
		{
			path: '/admin/organization-list',
			name: 'OrganizationList',
			component: OrganizationList
    },
		{
			path: '/admin/new-organization',
			name: 'AddOrganization',
			props: true,
			component: AddOrganization
    },
		{
			path: '/admin/new-primary-organization',
			name: 'AddPrimaryOrganization',
			props: true,
			component: AddPrimaryOrganization
    },
		{
			path: '/admin/organization/:id',
			name: 'EditOrganization',
			props: true,
			component: EditOrganization
    },
		{
			path: '/admin/organization-approval-list',
			name: 'OrganizationRequestList',
			component: OrganizationRequestList
    }
    ,
		{
			path: '/admin/organization-request/:id/edit',
			name: 'EditOrganizationRequest',
			props: true,
			component: EditOrganizationRequest
    }
    ,
		{
			path: '/approve-organization-registration/:jwt',
			name: 'ApproveOrganizationRegistration',
			props: true,
			component: ApproveOrganizationRegistration
    },
		{
			path: '/reject-organization-registration/:jwt',
			name: 'RejectOrganizationRegistration',
			props: true,
			component: RejectOrganizationRegistration
    },

		{
			path: '/admin/user-approval-list',
			name: 'AppUserRequestList',
			component: AppUserRequestList
        }
        ,
		{
			path: '/admin/user-request/:id/edit',
			name: 'EditAppUserRequest',
			props: true,
			component: EditAppUserRequest
        }
        ,
		{
			path: '/approve-user-registration/:jwt',
			name: 'ApproveUserRegistration',
			props: true,
			component: ApproveUserRegistration
        },
		{
			path: '/reject-user-registration/:jwt',
			name: 'RejectUserRegistration',
			props: true,
			component: RejectUserRegistration
        },

		{
			path: '/confirm-user-registration/:jwt',
			name: 'ConfirmAppUserRegistration ',
			props: true,
			component: ConfirmAppUserRegistration
        },
		{
			path: '/confirm-user-registration',
			name: 'ConfirmAppUserRegistration Empty',
			props: true,
			component: ConfirmAppUserRegistration
        },
		{
			path: '/register-organization',
			name: 'NewOrganization',
			props: true,
			component: NewOrganization
    },
		{
			path: '/confirm-organization-registration/:jwt',
			name: 'ConfirmOrganizationRegistration',
			props: true,
			component: ConfirmOrganizationRegistration
	},
		{
			path: '/confirm-organization-registration',
			name: 'ConfirmOrganizationRegistrationEmpty',
			props: true,
			component: ConfirmOrganizationRegistration
	},
		{
			path: '/create-account/:jwt',
			name: 'CreateAccount',
			props: true,
			component: CreateAccount
    },
		{
			path: '/create-account-from-pin/:jwt',
			name: 'CreateAccountFromPin',
			props: true,
			component: CreateAccountFromPin
        },
		{
			path: '/reset-password/:jwt',
			name: 'ResetPassword',
			props: true,
			component: ResetPassword
    },
		{
			path: '/forgot-password',
			name: 'ForgotPassword',
			component: ForgotPassword
    },
		{
			path: '/admin/new-user',
			name: 'AddUser',
			component: AddUser
    },
		{
			path: '/admin/user/:id',
			name: 'EditUser',
			props: true,
			component: EditUser
    },
		{
			path: '/admin/user-list',
			name: 'UserList',
			component: UserList
    },

		{
			path: '/admin/new-notification-schedule',
			name: 'AddNotificationSchedule',
			component: AddNotificationSchedule
        },
		{
			path: '/admin/notification-schedule/:id',
			name: 'EditNotificationSchedule',
			props: true,
			component: EditNotificationSchedule
        },
		{
			path: '/admin/notification-schedule-list',
			name: 'ListNotificationSchedule',
			component: ListNotificationSchedule
        },


		{
			path: '/my-settings',
			name: 'MySettings',
			component: MySettings,
			props: true
    },

		{
			path: '/my-notifications',
			name: 'MyNotifications',
			component: MyNotifications,
			props: true
        },
		{
			path: '/admin/user-approval-list',
			name: 'UserApprovalList',
			component: UnderDevelopment,
			props: {
				pageTitle: "User Requests",
				'pageBody': 'Under development'
			}
    },
		{
			path: '/admin/global-settings',
			name: 'EditGlobalSettings',
			component: EditGlobalSettings
    },
		{
			path: '/admin/audit-log-list',
			name: 'AuditLogList',
			component: AuditLogList,
    },
		{
			path: '/admin/audit-log/:id/view',
			name: 'ViewAuditLog',
			props: true,
			component: ViewAuditLog
    },
		{
			path: '/contraventions',
			name: 'ContraventionList',
			props: true,
			component: ContraventionList
    },
		{
			path: '/admin/banner/edit',
			name: 'EditBanner',
			component: EditBanner,
	},
  ]
})